import { getLocale } from "../runtime";

const sv_pricedescending = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Pris fallande`
};

const pricedescending = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_pricedescending(inputs)
	return "priceDescending";
};

export { pricedescending as "priceDescending" };